import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '数据概览', icon: 'el-icon-data-analysis', roles: ['admin', 'kefu', 'finance'] } },
      // 产品管理
      { path: 'product/list', name: 'ProductList', component: () => import('@/views/product/list.vue'), meta: { title: '产品列表', icon: 'el-icon-goods', roles: ['admin', 'kefu', 'finance'] } },
      // 订单管理
      { path: 'order/list', name: 'OrderList', component: () => import('@/views/order/list.vue'), meta: { title: '订单列表', icon: 'el-icon-s-order', roles: ['admin', 'kefu', 'finance'] } },
      { path: 'order/transfer-audit', name: 'TransferAudit', component: () => import('@/views/order/transfer-audit.vue'), meta: { title: '转单审核', icon: 'el-icon-sort', roles: ['admin', 'kefu', 'finance'] } },
      { path: 'after-sale/list', name: 'AfterSaleList', component: () => import('@/views/after-sale/list.vue'), meta: { title: '售后管理', icon: 'el-icon-warning-outline', roles: ['admin', 'kefu', 'finance'] } },
      // 打手管理
      { path: 'player/list', name: 'PlayerList', component: () => import('@/views/player/list.vue'), meta: { title: '打手列表', icon: 'el-icon-user', roles: ['admin', 'kefu', 'finance'] } },
      { path: 'player/audit', name: 'PlayerAudit', component: () => import('@/views/player/audit.vue'), meta: { title: '打手审核', icon: 'el-icon-circle-check', roles: ['admin', 'kefu', 'finance'] } },
      { path: 'player/level', name: 'PlayerLevel', component: () => import('@/views/player/level.vue'), meta: { title: '等级配置', icon: 'el-icon-trophy', roles: ['admin', 'kefu', 'finance'] } },
      // 财务管理
      { path: 'finance/withdraw', name: 'FinanceWithdraw', component: () => import('@/views/finance/withdraw.vue'), meta: { title: '提现管理', icon: 'el-icon-wallet', roles: ['admin', 'finance'] } },
      { path: 'finance/recharge', name: 'FinanceRecharge', component: () => import('@/views/finance/recharge.vue'), meta: { title: '客户充值', icon: 'el-icon-coin', roles: ['admin', 'finance'] } },
      { path: 'finance/transaction', name: 'FinanceTransaction', component: () => import('@/views/finance/transaction.vue'), meta: { title: '收支流水', icon: 'el-icon-document-checked', roles: ['admin', 'finance'] } },
      { path: 'finance/deposit', name: 'FinanceDeposit', component: () => import('@/views/finance/deposit.vue'), meta: { title: '押金管理', icon: 'el-icon-bank-card', roles: ['admin', 'finance'] } },
      // 客户管理
      { path: 'customer/list', name: 'CustomerList', component: () => import('@/views/customer/list.vue'), meta: { title: '客户列表', icon: 'el-icon-user-solid', roles: ['admin', 'kefu', 'finance'] } },
      // 系统配置
      { path: 'system/config', name: 'SystemConfig', component: () => import('@/views/system/config.vue'), meta: { title: '系统配置', icon: 'el-icon-setting', roles: ['admin', 'kefu', 'finance'] } },
      { path: 'system/accounts', name: 'AdminAccounts', component: () => import('@/views/system/accounts.vue'), meta: { title: '账号管理', icon: 'el-icon-user', roles: ['admin'] } },
    ]
  },
  // 404 兜底：匹配所有未定义的路由，重定向到首页
  { path: '*', redirect: '/dashboard' }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - 澜风渡电竞';
  }
  const token = localStorage.getItem('token');
  if (to.path === '/login') return next();
  if (!token) return next('/login');

  // 路由权限校验
  if (to.meta && to.meta.roles) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const role = userInfo.role || '';
    if (!to.meta.roles.includes(role)) {
      // 无权限，重定向到首页
      return next('/dashboard');
    }
  }
  next();
});

export default router;
